import { EnumStammdatenCounterTypes } from '@Model';
import { SelectOption } from '@synqo/frontend-component-library';

export function getStammdatenCounterName(counterType: EnumStammdatenCounterTypes): string {
    switch (counterType) {
        case EnumStammdatenCounterTypes.Address:
            return 'Adressenzähler';
        case EnumStammdatenCounterTypes.Service:
            return 'Leistungszähler';
        case EnumStammdatenCounterTypes.Debtor:
            return 'Debitor-Nummern';
        case EnumStammdatenCounterTypes.Creditor:
            return 'Kreditor-Nummern';
    }
}

export const stammdatenCounterTypes: EnumStammdatenCounterTypes[] = [
    EnumStammdatenCounterTypes.Address,
    EnumStammdatenCounterTypes.Service,
    EnumStammdatenCounterTypes.Debtor,
    EnumStammdatenCounterTypes.Creditor,
];

export const stammdatenCounterTypesItems: SelectOption<EnumStammdatenCounterTypes>[] = stammdatenCounterTypes.map(
    (counterType) => ({
        name: getStammdatenCounterName(counterType),
        value: counterType,
        label: getStammdatenCounterName(counterType),
    }),
);
